/**
 * TanStack Query hooks for `disallowed-traffic`. Thin wrappers over ./api.
 */
import {
	useMutation,
	useQuery,
	useQueryClient,
	type UseMutationResult,
	type UseQueryResult,
} from "@tanstack/react-query";
import {
	create,
	list,
	remove,
	disallowedTrafficQueryKeys,
	type CreateDisallowedTrafficBody,
	type ListDisallowedTrafficResponse,
	type DisallowedTrafficRow,
} from "./api";

export function useDisallowedTrafficList(): UseQueryResult<ListDisallowedTrafficResponse, Error> {
	return useQuery({
		queryKey: disallowedTrafficQueryKeys.list(),
		queryFn: list,
	});
}

export function useDisallowedTrafficCreate(): UseMutationResult<DisallowedTrafficRow, Error, CreateDisallowedTrafficBody> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: create,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: disallowedTrafficQueryKeys.all });
		},
	});
}

export function useDisallowedTrafficDelete(): UseMutationResult<{ removed: boolean }, Error, string> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: remove,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: disallowedTrafficQueryKeys.all });
		},
	});
}
